import { Component, OnInit } from '@angular/core';
import { CommissionReportService } from './commission-report.service';
import { format } from 'date-fns';
import { RoleNames } from '@pg-app/core/services/roles/RoleNames';
import { MatDialog } from '@angular/material/dialog';
import { RegistrationStep2Service } from '@pg-app/client/services/registrationStep2.service';
import { VatStatementComponent } from '@pg-app/partner/commission-report/vat-statement/vat-statement.component';
import { UtilityService } from '@nttp/common-service/utility-service';
import { DownloadFileTypeEnum } from '@nttp/enum/download-file-type-enum';
import { environment } from '@pg-env/environment';

@Component({
  selector: 'np-commission-report',
  templateUrl: './commission-report.component.html',
  styleUrls: ['./commission-report.component.scss']
})
export class CommissionReportComponent implements OnInit {
  commissionMonth: any;
  totalCommissionMonth: any;
  commissionFuture: any;
  totalCommissionFuture: any;
  commissionInfo: any;
  VIEW_REPORT = RoleNames.VIEW_REPORT;
  isVATRegistered: boolean;
  phone = environment.phone;
  domain = environment.domain;
  isPrivalgoMarkets = environment.isPrivalgoMarkets;
  brandName = environment.brandName;

  constructor(
    private commissionReportService: CommissionReportService,
    private utilityService: UtilityService,
    private dialog: MatDialog,
    private registerService: RegistrationStep2Service
  ) { }

  ngOnInit() {
    this.registerService.getAccountType().subscribe(res => {
      if (res.isVATRegistered === null) {
        const dialogRef = this.dialog.open(VatStatementComponent, {
          disableClose: true,
          data: {
            title: `Are you VAT registered? <br>
            You may need to send us an invoice for the commission you receive.<br>`,
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          this.updateVATRegister(result);
        });
      }
      this.isVATRegistered = res.isVATRegistered;
    });
    this.getCommissionData();
  }

  updateVATRegister(isVATRegistered) {
    this.commissionReportService.updateVATRegister(isVATRegistered).subscribe(res => {
      this.isVATRegistered = isVATRegistered;
    });
  }

  getCommissionData() {
    const params = {
      id: null,
      date: null,
      isFuture: false
    };
    this.commissionReportService.getPartnerInfoCommission(params).subscribe(x => {
      this.commissionInfo = x;
    });
    this.commissionReportService.getCommissionOfMonth(params).subscribe(resultMonth => {
      this.commissionMonth = resultMonth;
      this.totalCommissionMonth = resultMonth.map(item => item.partnerCommissionGBP ? item.partnerCommissionGBP : 0).reduce((a, b) => a + b, 0);

    });
    params.isFuture = true;
    this.commissionReportService.getCommissionOfMonth(params).subscribe(resultFuture => {
      this.commissionFuture = resultFuture;
      this.totalCommissionFuture = resultFuture.map(item => item.partnerCommissionGBP ? item.partnerCommissionGBP : 0).reduce((a, b) => a + b, 0);
    });
  }

  downloadCommissionPDF() {
    const params = {
      id: null,
      date: null
    };
    this.commissionReportService.downloadCommissionPDF(params).subscribe(data => {
      const date = new Date();
      const fileName = `Commission_Statement_Report_${format(date, 'DDMMYYYY')}.pdf`;
      this.utilityService.downloadFile(data, fileName, DownloadFileTypeEnum.PDF);
    });
  }

  downloadCommissionExcel() {
    const params = {
      id: null,
      date: null
    };
    this.commissionReportService.downloadCommissionExcel(params).subscribe(data => {
      const date = new Date();
      const fileName = `Commission_Statement_Report_${format(date, 'DDMMYYYY')}.xlsx`;
      this.utilityService.downloadFile(data, fileName, DownloadFileTypeEnum.PDF);
    });
  }

  downloadTemplate() {
    this.commissionReportService.downloadVATDocument().subscribe(res => {
      const fileName = `VAT Treatment of Introducers.pdf`;
      this.utilityService.downloadFile(res, fileName, DownloadFileTypeEnum.PDF);
    });
  }

  closeVATNotice() {
    this.isVATRegistered = null;
  }
}
